import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
import $currency from 'currency.js'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号',
    width: 150
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyName',
    fieldName: '公司名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号',
    width: 150
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号',
    width: 150
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderNo',
    fieldName: '内部单号',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'unit',
    fieldName: '单位',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'partsCost',
    fieldName: '出库成本(含税)',
    textAlign: 'right',
    isMoney: true,
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'partsCostWithoutTax',
    fieldName: '出库成本(不含税)',
    textAlign: 'right',
    isMoney: true,
    width: 130
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'partsTaxFee',
    fieldName: '出库成本税费',
    textAlign: 'right',
    isMoney: true,
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketCost',
    fieldName: '市场成本',
    textAlign: 'right',
    isMoney: true,
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outCost',
    fieldName: '外包成本',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { orderTaxRate } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount, orderTaxRate } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return totalPriceWithoutRate(orderFee, amount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount } = rowData
      // if (!orderTaxRate) {
      //   return orderFee
      // }
      return numberTimes(orderFee, amount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '税率',
    formatType: 'percent',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'title',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesManName',
    fieldName: '业务代表',
    width: 100
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoiceNo',
    fieldName: '发票号码',
    width: 100,
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => kk.no).join('，') : ''
    }
    // visible: (data) => {
    //   const { pageType, statusIn } = data
    //   return pageType === 'RECEIVED' && statusIn !== 4
    // }
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoicePrice',
    fieldName: '发票金额',
    width: 100,
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => $currency(kk.amount)).join('，') : ''
    }
    // visible: (data) => {
    //   const { pageType, statusIn } = data
    //   return pageType === 'RECEIVED' && statusIn !== 4
    // }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'urgentName',
    fieldName: '紧急程度',
    width: 100,
    visible: (data) => {
      const { pageType, statusIn } = data
      return pageType !== 'RECEIVED' && statusIn !== 4
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expectedCompletedDays',
    fieldName: '预计天数',
    width: 110,
    visible: (data) => {
      const { pageType, statusIn } = data
      return pageType !== 'RECEIVED' && statusIn !== 4
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairType',
    fieldName: '维修类型',
    width: 90,
    visible: (data) => {
      const { statusIn } = data
      return statusIn !== 4
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '业务类型',
    width: 90,
    visible: (data) => {
      const { statusIn } = data
      return statusIn !== 4
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    fieldName: '业务分类',
    width: 90,
    visible: (data) => {
      const { statusIn } = data
      return statusIn !== 4
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompanyName',
    fieldName: '外包商',
    visible: (data) => {
      const { statusIn } = data
      return statusIn !== 4
    }
  },

  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'outsourceCompanyContactName',
  //   fieldName: '外包联系'
  // },

  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '业务状态',
    width: 100
    // visible: (data) => {
    //   const { pageType, statusIn } = data
    //   return pageType !== 'RECEIVED' && statusIn !== 4
    // }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTimes',
    fieldName: '返修次数',
    width: 100
    // visible: (data) => {
    //   const { pageType, statusIn } = data
    //   return pageType !== 'RECEIVED' && statusIn !== 4
    // }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 100
    // visible: (data) => {
    //   const { statusIn } = data
    //   return statusIn !== 4
    // }
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'invoiceDate',
    fieldName: '开票日期',
    width: 120,
    formatValue: (data) => {
      const { details } = data
      return details ? details.map((kk: any) => kk.date).join('，') : ''
    }
    // visible: (data) => {
    //   const { statusIn } = data
    //   return statusIn === 4
    // }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'receivedStatus',
    fieldName: '收款状态',
    width: 100
  },
  {
    componentType: 'el-array',
    componentName: '输入框',
    fieldKey: 'receivedDate',
    fieldName: '收款日期',
    width: 100,
    formatValue: (data) => {
      const { receivedRecords } = data
      return receivedRecords ? receivedRecords.map((kk: any) => kk.date).join('，') : ''
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fault',
    fieldName: '故障描述'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateTime',
    fieldName: '申请时间',
    width: 160,
    visible: (data) => {
      const { businessTypeName } = data
      return ['TABLE_APPROVAL_CANCEL_BUSINESS', 'TABLE_APPROVAL_BUSINESS'].includes(businessTypeName)
    }
  }
]
